module.exports = __webpack_public_path__ + "static/media/main3_en.e48abb60.jpg";